import React, { useEffect, useState } from 'react';
import {
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material';
import { MenuItemProps } from '../drawer/BakeasyNavigationDrawer';
import { t } from 'i18next';
import { BLUE_GRAY_50, ORANGE_400, PRIMARY } from '../../constants/Colors';
import { ShoppingCart } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { draftOrderState } from '../../redux_store/slices/draftOrdersSlice';
import { useNavigate } from 'react-router-dom';
import { fetchStoreDetails } from '../../redux_store/slices/storeSlice';
import { fetchSupplierDetails } from '../../redux_store/slices/supplierSlice';
import { messagesState } from '../../redux_store/slices/messagesSlice';

export interface BakeasyListProps {
  items: MenuItemProps[];
  dense?: boolean;
  open?: boolean | false;
  onMouseOver?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onMouseOut?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function BakeasyList(props: BakeasyListProps) {
  const navigate = useNavigate();
  let _draftOrders: any = useAppSelector(draftOrderState);
  let _messagesState: any = useAppSelector(messagesState);
  const dispatch = useAppDispatch();
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    dispatch(fetchSupplierDetails(''));
    dispatch(fetchStoreDetails(''));
  }, []);

  async function handleCartClicked() {
    navigate('/createOrder', {
      state: { from: 'CartClick' }
    });
  }

  let itemsList = props.items.map((item: MenuItemProps) => {
    return (
      // <Box sx={{ overflowX: 'auto', display: 'flex', overflow: 'hidden' }}>
      <ListItem
        key={item.id}
        disablePadding
        sx={{
          display: 'block',
          color: selectedIndex === item.id ? PRIMARY : '',
          ':hover': { backgroundColor: BLUE_GRAY_50 }
        }}
      >
        <ListItemButton
          selected={selectedIndex === item.id}
          onMouseOver={(event: React.MouseEvent<HTMLDivElement>) => {
            if (props?.onMouseOver) props?.onMouseOver(event);
          }}
          onMouseOut={(event: React.MouseEvent<HTMLDivElement>) => {
            if (props?.onMouseOut) props?.onMouseOut(event);
          }}
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            event.stopPropagation();
            item.onClick(event);
            setSelectedIndex(item.id);
          }}
          sx={{ paddingX: props?.dense ? 1 : 2.5 }}
        >
          <Tooltip title={item.lable}>
            <ListItemIcon
              sx={{
                minWidth: 0,
                marginRight: props?.dense ? 1 : 3,
                color: selectedIndex === item.id ? PRIMARY : ''
              }}
            >
              {item.icon}
            </ListItemIcon>
          </Tooltip>

          <ListItemText>
            <div
              style={{
                fontWeight: selectedIndex === item.id ? 'bolder' : 'normal',
                ...(props?.open && {
                  overflow: 'clip',
                  wordWrap: 'break-word',
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word'
                })
              }}
            >
              {t(item.lable)}
            </div>
          </ListItemText>

          {item?.lable === 'CREATE_ORDER' && (
            <IconButton
              style={{ width: 22, height: 22 }}
              disabled={_draftOrders?.value?.data?.length === 0}
              onClick={(e: any) => {
                e.stopPropagation();
                setSelectedIndex(item.id);
                handleCartClicked();
              }}
            >
              <ShoppingCart
                color={_draftOrders?.value?.data?.length !== 0 ? 'error' : 'disabled'}
              />
            </IconButton>
          )}

          {item?.lable === 'MESSAGES' && _messagesState?.newMessageCount?.count && (
            <Avatar sx={{ backgroundColor: ORANGE_400, width: 22, height: 22 }}>
              <Typography sx={{ fontSize: '0.8rem' }}>
                {_messagesState?.newMessageCount?.count}
              </Typography>
            </Avatar>
          )}
        </ListItemButton>
      </ListItem>
      //</Box>
    );
  });
  return <List>{itemsList}</List>;
}

export default BakeasyList;
